import styled from 'styled-components';

export const RememberMeWrap = styled.div`
  margin-bottom: 1rem;
`;
